define(['text!./templates/basler-search-address.html'],
    (templateStr) => {

        return ['AddressLookupService', '$filter', 'DefaultErrorHandlerService',
            function (AddressLookupService, $filter, DefaultErrorHandlerService) {
                return {
                    restrict: 'A',
                    scope: {
                        model: '=qnbBaslerSearchAddress',
                        readonly: '=',
                    },
                    template: templateStr,

                    controller: ['$scope', function ($scope) {

                        const _MIN_CHARACTERS_SEARCH_ADDRESS = 3;

                        $scope.searchAddresses = searchAddresses;
                        $scope.streetChanged = streetChanged;
                        $scope.onStreetSelected = onStreetSelected;
                        $scope.callGroup = `textToStreet${Math.random()}`;
                        
                        if (!_.isEmpty($scope.model.addressLine1.value)) {
                            $scope.placeholder = $scope.model.addressLine1.value;
                        } else {
                            $scope.placeholder = $filter('translate')('quoteandbind.enterTextHere');
                        }
                        

                        /**
                         * This function is called from the typehead input. It looks for streets on the backend
                         */
                        function searchAddresses(userInput) {

                            if (userInput.length < _MIN_CHARACTERS_SEARCH_ADDRESS) {
                                return;
                            }

                            const promise = AddressLookupService.completeStreetName($scope.callGroup, userInput, $scope.model.postalCode.value, $scope.model.city.value);
                            promise.then((response) => {
                                if (!_.isEmpty(response)) {
                                    return response;
                                }

                            }, (error) => {
                                DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                            });

                            return promise;
                        }

                        /**
                         * Keeping logic of address change
                         */
                        function streetChanged(item) { //NOSONAR
                            // Do nothing for now - $scope.model.addressLine1.$setValidity(false);
                        }

                        /**
                         * This function copy the value of the selected vehicle type into the vehicle.
                         * @Param {model) ModelLookupResponseDTO - Model selected in 'model' dropdown. Even when only the name is displayed, all the DTO is received as parameter
                         */
                        function onStreetSelected(street) {
                            // Avoiding extra logic when the selected value is the already selected value
                            if (angular.isDefined(street) && street !== null && street) {
                                    $scope.model.addressLine1.value = street;
                                    $scope.streetSelected = true;
                            }
                        } // End of lookupVehicles

                    }],
                };
            },
        ];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerSearchAddress.js